import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicRoomSystemBaseAnalytics } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getRoomSystemBaseAnalytics = async (
  organisationId?: string,
  roomSystemId?: string,
): Promise<PublicRoomSystemBaseAnalytics> => {
  const response = await axiosClient.get(`/analytics/room-system-base`, {
    params: {
      ...(organisationId && { organisationId }),
      ...(roomSystemId && { roomSystemId }),
    },
  });
  return response.data;
};

export function getRoomSystemBaseAnalyticsQueryKey(
  organisationId?: string,
  roomSystemId?: string,
) {
  return ["room-system-base-analytics", organisationId, roomSystemId];
}

export function useGetRoomSystemBaseAnalytics(
  organisationId?: string,
  roomSystemId?: string,
  queryOptions?: Partial<
    UseQueryOptions<PublicRoomSystemBaseAnalytics, HttpError>
  >,
) {
  return useQuery({
    queryKey: getRoomSystemBaseAnalyticsQueryKey(organisationId, roomSystemId),
    queryFn: () => getRoomSystemBaseAnalytics(organisationId, roomSystemId),
    ...queryOptions,
  });
}
